import { jsx as _jsx } from "react/jsx-runtime";
import EnumMultiSelect from '../multiselect/EnumMultiSelect';
export const FilterEnumMultiSelect = ({ item, type, customItems = [], setFilter, activeFilters, label, isAlwaysVisible, enabled, itemMapper, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: (_jsx(EnumMultiSelect, { type: type, selection: activeFilters[item], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), placeholder: label, sortById: false, customItems: customItems, itemMapper: itemMapper })),
});
